import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const GuestRoute = ({ children }) => {
  const user = useSelector((state) => state.user);              // Get user state via Redux.
  return !user.uid ? children : <Navigate to="/user-registration" />;     // Redirect to home page if user.
};

GuestRoute.propTypes = {
  children: PropTypes.node.isRequired                           // Children to be rendered.
};

export default GuestRoute;
